/** Options for the Type column (stored as `source` on each ICD row). */
export const DX_CODE_ROW_TYPE_OPTIONS = [
  { id: "NCCN", label: "NCCN" },
  { id: "CMS", label: "CMS" },
  { id: "Custom", label: "Custom" },
];
